import React, { useState, useEffect } from 'react';
import { MessageCircle, Phone, X } from 'lucide-react';
import { Button } from './ui/button';

const StickyButtons = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const whatsappNumber = '919262626026';
  const phoneNumber = '+919262626026';
  const message = 'Hi! I want to know more about rooftop solar and subsidy for my home.';

  return (
    <>
      {/* WhatsApp Floating Button */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          if (window.fbq) {
            window.fbq('trackCustom', 'ContactClick', {
              contact_method: 'WhatsApp',
              button_location: 'Sticky Button'
            });
          }
        }}
        className={`fixed bottom-6 right-6 z-50 transition-all duration-300 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="relative group">
          <div className="absolute inset-0 bg-green-500 rounded-full blur-lg group-hover:blur-xl transition-all animate-pulse-subtle"></div>
          <Button
            size="lg"
            className="relative bg-green-500 hover:bg-green-600 text-white rounded-full w-16 h-16 shadow-2xl"
          >
            <MessageCircle className="w-7 h-7" />
          </Button>
        </div>
      </a>

      {/* Call Floating Button */}
      <a
        href={`tel:${phoneNumber}`}
        onClick={() => {
          if (window.fbq) {
            window.fbq('trackCustom', 'ContactClick', {
              contact_method: 'Phone',
              button_location: 'Sticky Button'
            });
          }
        }}
        className={`fixed bottom-28 right-6 z-50 transition-all duration-300 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="relative group">
          <div className="absolute inset-0 bg-orange-500 rounded-full blur-lg group-hover:blur-xl transition-all"></div>
          <Button
            size="lg"
            className="relative bg-orange-500 hover:bg-orange-600 text-white rounded-full w-16 h-16 shadow-2xl"
          >
            <Phone className="w-7 h-7" />
          </Button>
        </div>
      </a>
    </>
  );
};

export default StickyButtons;